import { VARIANTS } from 'shared';
import ButtonLink from 'shared_DEPRECATED/components/Button/ButtonLink';

import { SprintInfoProgressLine } from 'features/sprint/components/Info/ProgressLine';
import { useLastSprint } from 'features/sprint/hooks/useLastSprint';
import { useTimelineLink } from 'features/timeline/hooks/useTimelineLink';

export const SprintNavigationActive = () => {
  const lastSprint = useLastSprint();
  const sprintLink = useTimelineLink();

  return (
    <ButtonLink to={sprintLink} variant={VARIANTS.TERTIARY}>
      <SprintInfoProgressLine
        weekIndex={lastSprint.currentWeekNumber}
        successRate={lastSprint.successRate}
        status={lastSprint.state}
        weeksCount={lastSprint.weeksCount}
        title={lastSprint.title}
      />
    </ButtonLink>
  );
};
